// ─── STAT RESOLVER — league-aware dispatch to sport-specific stat functions ──
// Single entry point for all leagues. NHL live, MLB live, NFL collected (#1040 PR B)
// and settled (#1040 PR C: nfl is in SETTLEABLE_LEAGUES; GRADABLE_MARKETS_BY_LEAGUE.nfl
// bounds which markets grade).

import { getPlayerStat } from './nhl';
import { getPlayerStat as getMlbPlayerStat } from './mlb';
import { getPlayerStat as getNflPlayerStat } from './nfl';

/**
 * Resolve a player stat for the given league.
 * @param {string} league - League identifier ('nhl' | 'mlb' | 'nfl')
 * @param {Array} players - Parsed boxscore players array
 * @param {string} fullName - Player full name
 * @param {string} statType - Canonical stat type key
 * @param {number|null} legPlayerId - Optional player ID for direct match
 * @returns {number|null} Stat value or null
 */
export function getPlayerStatForLeague(league, players, fullName, statType, legPlayerId) {
  switch (league) {
    case 'nhl':
      return getPlayerStat(players, fullName, statType, legPlayerId);
    case 'mlb':
      return getMlbPlayerStat(players, fullName, statType, legPlayerId);
    case 'nfl':
      // #1353 PR 2 (r5.6): anytime TD is identity-checked on the server by roster id; the
      // client never re-derives it by name -- callers use the persisted frozenStat ?? statValue.
      if (statType === 'nfl:anytime_td') return null;
      return getNflPlayerStat(players, fullName, statType, legPlayerId);
    case 'nba':
      // #1655 B3a item 5: NBA has no stat resolver until plan C2. A known league, not an
      // unknown one -- return null quietly instead of warning on every SlipTicket render.
      return null;
    default:
      console.warn(`[stat-resolver] Unknown league: ${league}`);
      return null;
  }
}
